<template>
  <div class="user-details-connection-speed">
    <div class="panel-title">
      <span>Avg Connection Speed</span>
      <i class="far fa-question-circle" data-toggle="tooltip" title="Not all meeting platforms support connection speed"></i>
    </div>
    <div class="highcharts-light connection-speed-info-container">
      <div v-if="hasNoData" class="no-data-message">
        No Data To Display
      </div>
      <div v-if="wifi" class="connection-speed-info-row">
        <div class="connection-speed-icon"><i :class="getIconClass(wifi.quality)"></i></div>
        <div class="connection-speed-text">Wifi</div>
        <div :class="{'connection-speed-value': true, 'semantic-bad': wifi.quality==='bad'}">{{ wifi.val }}</div>
      </div>
      <div v-if="ethernet" class="connection-speed-info-row">
        <div class="connection-speed-icon"><i :class="getIconClass(ethernet.quality)"></i></div>
        <div class="connection-speed-text">Ethernet</div>
        <div :class="{'connection-speed-value': true, 'semantic-bad': ethernet.quality==='bad'}">{{ ethernet.val }}</div>
      </div>
      <div v-if="cell" class="connection-speed-info-row">
        <div class="connection-speed-icon"><i :class="getIconClass(cell.quality)"></i></div>
        <div class="connection-speed-text">Cellular</div>
        <div :class="{'connection-speed-value': true, 'semantic-bad': cell.quality==='bad'}">{{ cell.val }}</div>
      </div>
      <div v-if="vpn" class="connection-speed-info-row">
        <div class="connection-speed-icon"><i :class="getIconClass(vpn.quality)"></i></div>
        <div class="connection-speed-text">VPN</div>
        <div :class="{'connection-speed-value': true, 'semantic-bad': vpn.quality==='bad'}">{{ vpn.val }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'user-details-connection-speed-panel',
  props: {
    wifi: {
      type: Object,
      default: () => {}
    },
    ethernet: {
      type: Object,
      default: () => {}
    },
    cell: {
      type: Object,
      default: () => {}
    },
    vpn: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasNoData: function() {
      return !this.wifi && !this.ethernet && !this.cell && !this.vpn;
    }
  },
  methods: {
    getIconClass: function(quality) {
      if (quality) {
        if (quality === 'bad') {
          return 'fas fa-tachometer-slow semantic-bad';
        }
        if (quality === 'fair') {
          return 'fas fa-tachometer-average semantic-fair';
        }
        if (quality === 'good') {
          return 'fas fa-tachometer semantic-good';
        }
      }
      return 'fas fa-tachometer semantic-good';
    }
  }
}
</script>

<style lang="scss" scoped>
.user-details-connection-speed {
  color: var(--text-color);
  .panel-title {
    font-size: 18px;
    font-weight: bold;
    color: var(--filter-text-color);
    text-align: center;
    padding-top: 16px;
    padding-bottom: 20px;

    .far.fa-question-circle {
      font-size: 10px;
      vertical-align: text-top;
    }
  }

  .connection-speed-info-container {
    position: relative;
    display: table;
    margin: 0 auto;
    font-size: 16px;
    
    .no-data-message {
      font-weight: 700;
      font-size: 0.8em;
      color: var(--highcharts-neutral-color-60);
      margin-top: 40px;
    }

    .connection-speed-info-row {
      display: table-row;
      font-size: 14px;

      div {
        display: table-cell;
        padding-bottom: 8px;
      }

      .connection-speed-icon {
        padding-right: 11px;
        i {
          font-size: 14px;
        }
      }

      .connection-speed-value {
        padding-left: 10px;
        font-weight: bold;
      }
    }
  }
}
</style>
